// import Profile from '../../components/auth/Profile' // for testing profile user login

import EcommerceTopbar from '../../components/ecommerce/EcomTopBar'
import EcommerceNavbar from '../../components/ecommerce/EcomNavbar'
import EcommerceFooter from '../../components/ecommerce/EcomFooter'
import { Outlet } from 'react-router-dom'
import { useRef } from 'react'
import classNames from 'classnames'

export default function EcommerceLayout() {
  const containerRef = useRef<HTMLDivElement | null>(null)
  // adds shadow to navbar when user scrolls down, removed right now for sake of making store page stackable/sticky components blend in better
  // useEffect(() => {
  //   const toggleShadowClass = () => {
  //     if (window.scrollY > 300) {
  //       containerRef.current?.classList.add('navbar-shadow')
  //     } else {
  //       containerRef.current?.classList.remove('navbar-shadow')
  //     }
  //   }

  //   document.addEventListener('scroll', () => toggleShadowClass())

  //   return () => document.removeEventListener('scroll', toggleShadowClass)
  // }, [])

  return (
    <>
      <div className="">
        <div className={classNames('bg-soft sticky-top landing-navbar')} ref={containerRef}>
          <EcommerceTopbar />
          <EcommerceNavbar />
        </div>
        <div>
          <Outlet />
        </div>
        <EcommerceFooter />
      </div>
    </>
  )
}
